import { trackDomainsEvent } from "../analytics";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackLearnMoreClicked = () => trackDomainsEvent("'Learn more' clicked");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackAddDomainModalClosed = () => trackDomainsEvent("Add domain modal closed");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackOpenConfirmationModal = () => trackDomainsEvent("Open confirmation modal");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackBackToAddingClicked = () => trackDomainsEvent("Back to adding clicked on confirmation modal");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackIllDoItLaterClicked = () => trackDomainsEvent("I'll do it later clicked on confirmation modal");

export const trackAddDomainModalOpened = (source: "empty_state" | "main" | "onboarding_checklist"): void =>
  trackDomainsEvent("Add domain modal opened", {
    source,
  });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackDeleteDomainModalOpened = () => trackDomainsEvent("Delete domain modal opened");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackSetupModalChatWithUsClicked = () => trackDomainsEvent("Setup modal 'Chat with us' clicked");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackSetupModalLearnMoreClicked = () => trackDomainsEvent("Setup modal Help Center link clicked");
